/* 劉備傳・第 9 章：定軍山（建安二十四年，219）
 * 史實：《三國志·法正傳》劉備在定軍山、興勢作營，夏侯淵領兵來爭。「正曰：『可擊矣。』先主命黃忠乘高鼓譟攻之，大破淵軍，淵等授首。」
 *       《夏侯淵傳》：淵分所將兵半助張郃，自將輕兵護南圍的鹿角。
 * 流程：操作黃忠在定軍山上待命。山下夏侯淵的兵一點點分散（一半去東邊助張郃，一部分去修鹿角）。
 *       等法正喊「可擊矣」再衝下山（鼓譟：攻擊、移速上升）。太早衝，夏侯淵的兵還沒分散；太晚，鹿角修好，營門關上。斬夏侯淵即勝利。
 *       （和曹操傳第 12 章同一場仗、同一張圖。） */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, hero, TROOPS, rout } from '../kit.ts';
import { HILL, CAMP, ABATIS } from '../maps/dingjun.ts';

const LV = 15, SIGNAL_T = 30, LATE_T = 52;
const WEI = { spec: TROOPS.wei, name: '魏軍', hp: 500, maxHp: 500, atk: 28 };

export default {
  id: 'liubei-9', map: 'dingjun', hero: 'huangzhong',
  title: '第 9 章　定軍山', year: '建安二十四年（219）',
  brief: {
    quote: [{ text: '正曰：「可擊矣。」先主命黃忠乘高鼓譟攻之，大破淵軍，淵等授首。', src: '《三國志·蜀書·法正傳》' }],
    text: '劉備進兵漢中，在定軍山扎營。夏侯淵領兵來爭，分兵去修被燒的鹿角、救援東邊的張郃。法正在山上看著魏軍的動靜。',
    goals: ['在山上待命，等法正判斷時機', '鼓譟衝下山', '斬夏侯淵'],
  },
  words: { ally: '蜀兵', foe: '魏軍' },
  stars: [
    { text: '等法正喊「可擊矣」才衝，而且沒拖到鹿角修好', ok: (m) => m.vars.chargeT != null && m.vars.chargeT >= SIGNAL_T && m.vars.chargeT < LATE_T },
    { text: '衝下山後 60 秒內斬夏侯淵', ok: (m) => m.vars.killT != null && m.vars.killT - m.vars.chargeT < 60 },
    { text: '蜀兵折損不超過 3 人', ok: (m) => m.stats.lost <= 3 },
  ],
  steps: [
    { // 1. 山上待命
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = HILL[0]; me.y = HILL[1] + 100;
        V.t0 = w.t;
        V.fa = ally(w, 'fazheng', HILL[0] - 150, HILL[1] + 40, LV); V.fa.hold = [HILL[0] - 150, HILL[1] + 40];
        V.men = Array.from({ length: 8 }, (_, i) => { const u = m.recruit(HILL[0] - 200 + (i % 4) * 100, HILL[1] + 200 + Math.floor(i / 4) * 80, '蜀兵'); u.spec = TROOPS.shu; m.join(u, me); return u; });
        V.yuan = boss(w, hero('xiahouyuan'), CAMP[0], CAMP[1], { name: '夏侯淵', hp: 4400, atk: 52, armor: 9 });
        V.camp = Array.from({ length: 16 }, (_, i) => { const a = (i / 16) * Math.PI * 2, u = m.foe('huangjin', CAMP[0] + Math.cos(a) * 320, CAMP[1] + Math.sin(a) * 220, WEI); u.home = [u.x, u.y]; return u; });
        ABATIS.forEach(([x, y], k) => m.folk(x, y, { name: '鹿角', still: true, near: 1, draw: abatis, fixed: false }));
        m.line('法正', '漢升將軍稍安，待淵分兵，再擊不遲。');
        m.after(4, () => m.line('提示', '先在山上待命（地上的圈內）。等法正喊「可擊矣」再衝下山；太早或太晚都會吃虧。'));
        m.obj('wait', '');
        m.mark('hill', HILL[0], HILL[1] + 100, '待命');
      },
      tick(m, w) {
        const me = w.player, V = m.vars, t = w.t - V.t0;
        // 夏侯淵分兵：一半往東助張郃（離開地圖），一部分去修鹿角
        V.camp.forEach((u, i) => {
          if (!u.alive || u.left) return;
          if (i % 2 === 0 && t > 6 + i * 1.2) { u.left = true; u.home = [8800, 3200]; m.after(10, () => { if (u.alive) { u.alive = false; u.counted = true; } }); }
          else if (i % 4 === 1 && t > 10 + i) { u.home = [ABATIS[i % 3][0], ABATIS[i % 3][1] + 60]; }
        });
        if (t > SIGNAL_T && !V.signal) { V.signal = true; m.big('可擊矣！'); m.line('法正', '淵兵已分，可擊矣！'); }
        if (t > LATE_T && !V.late) { V.late = true; m.line('法正', '……鹿角補好了，晚了一步。'); ABATIS.forEach((p, k) => { m.gate('ab' + k, p[0], p[1], 220, 'abatis'); }); for (const f of m.folks) if (f.name === '鹿角') f.fixed = true; }
        m.get('wait').text = V.signal ? '衝下山，斬夏侯淵' : `在山上待命（法正在看魏軍的動靜…）`;
        if (SG.gd(me.x, me.y, HILL[0], HILL[1]) > 650) { V.chargeT = t; return true; }
        return false;
      },
    },
    { // 2. 乘高鼓譟
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.unmark('hill');
        if (V.chargeT < SIGNAL_T) {
          m.line('法正', '將軍太急了！淵兵還未分！');
          for (const u of m.alive(V.camp)) { u.left = false; u.home = [CAMP[0] + (SG.rand() - 0.5) * 500, CAMP[1] - 300]; } // 兵都還在
          w.addBuff(V.yuan, { id: '陣勢完整', t: 30, atkP: 0.25 });
        } else {
          m.card('先主命黃忠乘高鼓譟攻之。', '《法正傳》');
          for (const u of [me, ...m.alive(V.men)]) w.addBuff(u, { id: '鼓譟', t: 16, atkP: 0.35, ms: 0.25 });
        }
        V.yuan.home = [me.x, me.y];
        m.mark('yuan', V.yuan.x, V.yuan.y, '夏侯淵', false, V.yuan);
        m.obj('yuan', '斬夏侯淵');
      },
      tick(m, w) {
        const V = m.vars;
        if (V.yuan.alive) return false;
        V.killT = w.t - V.t0;
        return true;
      },
    },
    { // 3. 淵等授首
      enter(m, w) {
        const V = m.vars;
        m.done('wait'); m.done('yuan'); m.unmark('yuan');
        m.card('大破淵軍，淵等授首。', '《法正傳》');
        rout(m, w, V.camp, [8800, 3200]);
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('黃忠陣亡'); return; }
    if (m.vars.fa) allyTick(w, m.vars.fa, null, 300);
  },
};

// 鹿角：被燒的是焦黑歪斜的木樁，修好的是削尖的木樁交叉排開
function abatis(ctx, f, T) {
  ctx.save(); ctx.translate(f.x, f.y);
  ctx.lineCap = 'round';
  for (let i = 0; i < 5; i++) {
    const x = -90 + i * 45;
    ctx.strokeStyle = f.fixed ? '#5a3a22' : '#2a2420'; ctx.lineWidth = 6;
    ctx.beginPath(); ctx.moveTo(x - 16, 6); ctx.lineTo(x + 12, f.fixed ? -44 : -24); ctx.moveTo(x + 16, 6); ctx.lineTo(x - 12, f.fixed ? -44 : -18); ctx.stroke();
  }
  ctx.restore();
}
